import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { DragSource as dragSource } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';
import AutocodeCheckBox from '../../ACShared/AutocodeCheckBox';
import TargetDefinationMenu from '../AutocodeDefinationMenu/TargetDefinationMenu';
import { AC_PERSONAL_FOLDER_SCOPE } from '../../AutocodeConstants';
import { useACProjectContext } from '../../ACContext/ACDefinitionContext';
import { useACEditContext } from '../../ACContext/ACEditContext';
import AC_GRID from '../../AutocodeTypes';

let selectedDefData;

const source = {
  beginDrag() {
    return {
      selectedNodes: selectedDefData,
      ACTemplateType: AC_GRID.AC_DEFINITIONS,
    };
  },
  endDrag(props, monitor) {
    if (monitor.didDrop()) {
      props.handleDragEnd();
    }
  },
};

const collect = (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  connectDragPreview: connect.dragPreview(),
  isDragging: monitor.isDragging(),
});

const TargetDefinitionDragableRow = ({
  // allDefinitionTarget = null,
  selectDefination,
  selectedFolder,
  data,
  connectDragSource,
  connectDragPreview,
  onDelete,
}) => {
  useEffect(() => {
    connectDragPreview(getEmptyImage(), {
      captureDraggingState: true,
    });
  }, []);
  const { defDataPoints } = useACProjectContext();
  const { showTargetEllipsis } = useACEditContext();

  selectedDefData = defDataPoints;

  const _handleOnRowSelect = (checkState, row, event) => {
    event = event || false;
    selectDefination(checkState, row, false, event);
  };

  const _onDelete = () => {
    onDelete(data);
  };

  const keyHandler = event => {
    if (
      (event.key === 'Delete' &&
        selectedFolder.selectedFolder.scope ===
          AC_PERSONAL_FOLDER_SCOPE.value1) ||
      selectedFolder.selectedFolder.scope === AC_PERSONAL_FOLDER_SCOPE.value2
    ) {
      onDelete(data);
    }
  };

  return connectDragSource(
    <div
      className={`ac--def--table__row ${
        data.checkState ? 'ac--def--table__row--checked' : ''
      }`}
      key={data.expressionId}
    >
      <div className="ac--def--table__col" onKeyDown={keyHandler}>
        <AutocodeCheckBox
          onChange={_handleOnRowSelect}
          id={`ct_select_${data.expressionId}`}
          isChecked={data.checkState}
          data={data}
          label={data.title}
          disableCheck={data.display === false}
        />
      </div>
      {showTargetEllipsis &&
        defDataPoints.length < 2 &&
        data.display &&
        selectedFolder &&
        selectedFolder.selectedFolder &&
        (selectedFolder.selectedFolder.scope ===
          AC_PERSONAL_FOLDER_SCOPE.value1 ||
          selectedFolder.selectedFolder.scope ===
            AC_PERSONAL_FOLDER_SCOPE.value2) && (
          <span
            style={{ marginRight: '6px' }}
            className="row pull-right ac--def__target-menu"
            onClick={() => !data.checkState && _handleOnRowSelect(true, data)}
            data-test="Target-def-menu"
          >
            <TargetDefinationMenu
              item={selectedFolder}
              fill="black"
              onDelete={_onDelete}
            />
          </span>
        )}
    </div>
  );
};

TargetDefinitionDragableRow.propTypes = {
  allDefinitionTarget: PropTypes.shape({ data: PropTypes.shape([]) }),
  selectDefination: PropTypes.func,
  onDelete: PropTypes.func,
  selectedFolder: PropTypes.shape({
    selectedFolder: {
      scope: PropTypes.number,
    },
  }),
};

export default dragSource(
  AC_GRID.AC_DEFINITIONS,
  source,
  collect
)(TargetDefinitionDragableRow);
